var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon20PxSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/20px/settings [#1491]") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.8748682,0 C17.2204905,0 17.4998633,0.279997813 17.4998633,0.624995117 L17.499,9.116 L18.9329771,7.68306498 C19.1773502,7.43869189 19.5723471,7.43869189 19.8167202,7.68306498 C20.0610933,7.92743807 20.0610933,8.32243498 19.8167202,8.56680807 L17.3167397,11.0667885 C17.2920191,11.0913454 17.2725924,11.1080292 17.2521838,11.1234871 L17.3167397,11.0667885 C17.2903576,11.0931707 17.2621889,11.116712 17.2326205,11.1374061 C17.2123078,11.1519253 17.1906915,11.1651773 17.1682586,11.1771024 C17.1619488,11.1802135 17.1558673,11.1833185 17.1497468,11.1863176 C17.1283396,11.1970371 17.1060562,11.2064023 17.083158,11.214473 C17.0767142,11.2165428 17.0705826,11.2185964 17.0644267,11.2205523 C16.9983589,11.2406766 16.9377086,11.2499121 16.8748682,11.2499121 C16.8120277,11.2499121 16.7513774,11.2406766 16.6941981,11.2234867 C16.6791537,11.2185964 16.6730221,11.2165428 16.6669174,11.2143916 C16.6436801,11.2064023 16.6213967,11.1970371 16.5998156,11.1864651 C16.593869,11.1833185 16.5877876,11.1802135 16.5817479,11.1770028 C16.5590448,11.1651773 16.5374285,11.1519253 16.5167327,11.1374507 C16.510313,11.132645 16.5035842,11.1277331 16.4969342,11.1226706 C16.4784126,11.1089316 16.461047,11.0941599 16.4445382,11.0784943 C16.4411639,11.0748461 16.4370591,11.070851 16.4329966,11.0667885 L13.9330161,8.56680807 C13.6886431,8.32243498 13.6886431,7.92743807 13.9330161,7.68306498 C14.1773892,7.43869189 14.5723862,7.43869189 14.8167592,7.68306498 L16.249,9.116 L16.249873,0.624995117 C16.249873,0.279997813 16.5292459,0 16.8748682,0 Z M8.74993164,8.74993164 C9.09492895,8.74993164 9.37492676,9.02930446 9.37492676,9.37492676 C9.37492676,9.72054906 9.09492895,9.99992188 8.74993164,9.99992188 L4.37496582,9.99992188 C4.02996852,9.99992188 3.7499707,9.72054906 3.7499707,9.37492676 C3.7499707,9.02930446 4.02996852,8.74993164 4.37496582,8.74993164 L8.74993164,8.74993164 Z M10.624917,4.99996094 C10.9705393,4.99996094 11.2499121,5.27995875 11.2499121,5.62495606 C11.2499121,5.96995336 10.9705393,6.24995117 10.624917,6.24995117 L2.49998047,6.24995117 C2.15498316,6.24995117 1.87498535,5.96995336 1.87498535,5.62495606 C1.87498535,5.27995875 2.15498316,4.99996094 2.49998047,4.99996094 L10.624917,4.99996094 Z M12.5567769,1.25874017 C12.9023992,1.25874017 13.181772,1.53873798 13.181772,1.88373528 C13.181772,2.22873259 12.9023992,2.5087304 12.5567769,2.5087304 L0.624995117,2.5087304 C0.279997813,2.5087304 0,2.22873259 0,1.88373528 C0,1.53873798 0.279997813,1.25874017 0.624995117,1.25874017 L12.5567769,1.25874017 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work-in-progress",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filters-MVP/Date",
    transform: "translate(-1390.000000, -136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/sort",
    transform: "translate(1390.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2699\\uFE0FAtoms/Colour/Grey",
    transform: "translate(0.000000, 3.750000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2699\\uFE0FAtoms/Colour/Grey/4",
    mask: "url(#mask-2)",
    fill: "#8A8E96"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -3.750000)",
    id: "Colour"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxSort);
export default __webpack_public_path__ + "static/media/icon_20px_sort.2008633c90d72ceb59932cbf6ea200a4.svg";
export { ForwardRef as ReactComponent };